<!--  -->
<template>
  <div>
    <div class="mainCont">
      <div class="def-container">
        <h1 class="main_title">{{ userInfo.enterpriseInfo.enterprise }}</h1>
        <!-- <p class="desc">
          平台根据您填写的简历信息提供政策智能匹配服务，最终申报结果以政府公示为准。
        </p> -->
        <div class="line">
          <div class="line_label">统一社会信用代码：</div>
          <div class="line_value">{{ userInfo.tyshxydm }}</div>
          <!--          <el-button type="primary" @click="openPolicy()">完善企业信息</el-button>-->
        </div>
        <div class="line">
          <div class="line_label">注册地：</div>
          <div class="line_value">河南郑州</div>
        </div>
        <div class="line">
          <div class="line_label">
            推荐申报政策{{
              tabActive == "project" ? "项目" : ""
            }}（符合申报条件）：
          </div>
          <div class="line_value">
            <span style="color: orange" v-if="totleMap2.qb || totleMapDept.qb"
              >{{
                tabActive == "project" ? policyData2.num : totleMap2.qb
              }}条</span
            >
            <span style="color: orange" v-else>0条</span>
          </div>
        </div>
        <div class="line" v-if="tabActive == 'project'">
          <div class="line_label">预估可申报资金：</div>
          <div class="line_value">
            <span style="color: orange" v-if="totleMapDept.zzxe"
              >{{
                tsFlag == "dept" ? policyData2.zj : totleMap.zzxe
              }}万元</span
            >
            <span style="color: orange" v-else>0万元</span>
          </div>
        </div>
        <!-- <a href="#" class="line_link">完善信息，匹配更多政策 </a> -->
      </div>
    </div>
    <div style="width: 100%; background: #f0f2f5">
      <div class="def-container flex-row tabCon">
        <div
          class="tabItem"
          :class="{ clicked: tabActive == 'policy' }"
          @click="changeTab('policy')"
        >
          政策推送
        </div>
        <div
          class="tabItem"
          :class="{ clicked: tabActive == 'project' }"
          @click="changeTab('project')"
        >
          政策项目推送
        </div>
      </div>
    </div>
    <!-- <div class="navRadio" v-if="tabActive == 'project'">
      <div class="def-container flex-row">
        <div
          class="radioItem"
          :class="{ clicked: tsFlag == 'dept' }"
          @click="radioChange('dept')"
        >
          智能系统推送
        </div>
        <div
          class="radioItem"
          :class="{ clicked: tsFlag == 'system' }"
          @click="radioChange('system')"
        >
          系统推送
        </div>
      </div>
    </div> -->
    <!-- 政策项目--系统推荐 -->
    <div v-if="tabActive == 'project' && tsFlag == 'system'">
      <div class="report-container">
        <div class="report-container__filter def-container">
          <div
            :class="
              titleType == -1
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(-1)"
          >
            全部（{{ this.totleMap.qb }}）
          </div>
          <div
            :class="
              titleType == 0
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(0)"
          >
            国家级（{{ this.totleMap.gj }}）
          </div>
          <div
            :class="
              titleType == 1
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(1)"
          >
            省级（{{ this.totleMap.sj }}）
          </div>
          <div
            :class="
              titleType == 2
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(2)"
          >
            市级（{{ this.totleMap.dsj }}）
          </div>
          <!-- <div
            :class="
              titleType == 3
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(3)"
          >
            区县级（{{ this.totleMap.xj }}）
          </div> -->
          <div
            style="float: right"
            v-show="tsFlag == 'system' && tabActive == 'project'"
          >
            <el-button type="primary" @click="openPolicy()"
              >完善企业信息</el-button
            >
          </div>
        </div>
      </div>
      <div
        class="qw-list-empty def-container"
        v-if="showFlag && policyInfo.data.length == 0"
      >
        <div class="qw-list-empty__inner">
          <div>
            <i class="el-icon-folder-delete"></i>
          </div>
          <div><span> 暂无数据 </span></div>
        </div>
      </div>
      <div
        class="qw-list-empty def-container"
        v-if="!showFlag && policyInfo.data.length == 0"
      >
        <div class="qw-list-empty__inner">
          <div>
            <i class="el-icon-folder-delete"></i>
          </div>
          <div>
            <span> 您尚未完善企业信息，现在去</span>
            <span
              @click="policyVisible = true"
              style="color: #0d55cf; font-weight: bold; cursor: pointer"
              >完善</span
            >。
          </div>
        </div>
      </div>
      <div v-else class="def-container" v-load="loading">
        <div
          class="box-card"
          v-for="(item, index) in policyInfo.data"
          :key="index"
        >
          <el-row style="margin-bottom: 8px">
            <span style="color: #0069e8; font-size: 16px"
              >【{{ item.areaid }}】</span
            >
            <span
              style="color: #333; font-weight: 700; font-size: 16px"
              @click="tonewpage(item)"
              >{{ item.name }}</span
            >
            <span class="match" v-show="tsFlag == 'system'"
              >匹配度：{{ item.ppd.toFixed(2) }}%</span
            >
          </el-row>
          <!-- <el-row class="box-line">
          <el-col :span="2" class="box-line-title">发布日期:</el-col>
          <el-col :span="20">{{
            moment(item.starttime).format("YYYY-MM-DD")
          }}</el-col>
        </el-row> -->
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">发文单位:</el-col>
            <el-col :span="20">{{ item.deptname }}</el-col>
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">政策名称:</el-col>
            <el-col :span="20">{{ item.policyName }}</el-col>
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">申报时间:</el-col>
            <el-col :span="20"
              >{{ moment(item.starttime).format("YYYY-MM-DD") }}至{{
                cpu_limitTime(moment(item.endtime).format("YYYY-MM-DD"))
              }}
            </el-col>
          </el-row>
          <el-row class="box-line" v-show="tsFlag == 'dept'">
            <el-col :span="2" class="box-line-title">推送时间:</el-col>
            <el-col :span="20">{{ item.pushTime }}</el-col>
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">扶持资金:</el-col>
            <el-col :span="20">{{ item.zzxe || 0 }}（万元）</el-col>
          </el-row>
          <div class="zct-policy-item-comp__rect is-grey" v-if="!item.ksbflag">
            非申报期
          </div>
          <div v-else class="zct-policy-item-comp__rect is-blue">申报期</div>
          <div class="wssb">
            <el-button
              type="primary"
              :disabled="!item.ksbflag"
              @click="goDeclare(item)"
              >项目详情</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 政策项目--部门推荐 -->
    <div v-if="tabActive == 'project' && tsFlag == 'dept'">
      <div class="report-container">
        <div class="report-container__filter def-container">
          <div
            :class="
              titleType == -1
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(-1)"
          >
            全部（{{ this.totleMapDept.qb }}）
          </div>
          <div
            :class="
              titleType == 0
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(0)"
          >
            国家级（{{ this.totleMapDept.gj }}）
          </div>
          <div
            :class="
              titleType == 1
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(1)"
          >
            省级（{{ this.totleMapDept.sj }}）
          </div>
          <div
            :class="
              titleType == 2
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check(2)"
          >
            市级（{{ this.totleMapDept.dsj }}）
          </div>
          <!--        <div
          :class="
            titleType == 3
              ? 'report-container__filter__item is-active'
              : 'report-container__filter__item'
          "
          @click="check(3)"
        >
          区县级（{{ this.totleMap.xj }}）
        </div>-->
        </div>
      </div>
      <div
        class="qw-list-empty def-container"
        v-if="showFlag && policyInfo.deptData.length == 0"
      >
        <div class="qw-list-empty__inner">
          <div>
            <i class="el-icon-folder-delete"></i>
          </div>
          <div><span> 暂无数据 </span></div>
        </div>
      </div>
      <div
        class="qw-list-empty def-container"
        v-if="!showFlag && policyInfo.deptData.length == 0"
      >
        <div class="qw-list-empty__inner">
          <div>
            <i class="el-icon-folder-delete"></i>
          </div>
          <div>
            <span> 您尚未完善企业信息，现在去</span>
            <span
              @click="policyVisible = true"
              style="color: #0d55cf; font-weight: bold; cursor: pointer"
              >完善</span
            >。
          </div>
        </div>
      </div>
      <div v-else class="def-container">
        <div
          class="box-card"
          v-for="(item, index) in policyInfo.deptData"
          :key="index"
        >
          <el-row style="margin-bottom: 8px">
            <span style="color: #0069e8; font-size: 16px"
              >【{{ item.areaid }}】</span
            >
            <span
              style="color: #333; font-weight: 700; font-size: 16px"
              @click="goDeclare(item)"
              >{{ item.name }}</span
            >
<!--            @click="tonewpage(item)"-->
          </el-row>
          <!-- <el-row class="box-line">
          <el-col :span="2" class="box-line-title">发布日期:</el-col>
          <el-col :span="20">{{
            moment(item.starttime).format("YYYY-MM-DD")
          }}</el-col>
        </el-row> -->
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">发文单位:</el-col>
            <el-col :span="20">{{ item.deptname }}</el-col>
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">政策名称:</el-col>
            <el-col :span="20">{{ item.policyName }}</el-col>
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">申报时间:</el-col>
            <el-col :span="20"
              >{{ moment(item.starttime).format("YYYY-MM-DD") }}至{{
                cpu_limitTime(moment(item.endtime).format("YYYY-MM-DD"))
              }}
            </el-col>
          </el-row>
          <el-row class="box-line" v-show="tsFlag == 'dept'">
            <el-col :span="2" class="box-line-title">推送时间:</el-col>
            <el-col :span="20">{{ item.pushTime }}</el-col>
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">扶持资金:</el-col>
            <el-col :span="20">{{ item.zzxe || 0 }}（万元）</el-col>
          </el-row>
          <div class="zct-policy-item-comp__rect is-grey" v-if="!item.ksbflag">
            非申报期
          </div>
          <div v-else class="zct-policy-item-comp__rect is-blue">申报期</div>
          <div class="wssb">
            <el-button
              type="primary"
              :disabled="!item.ksbflag"
              @click="goDeclare(item)"
              >项目详情</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 政策推送 -->
    <div v-if="tabActive == 'policy'">
      <div class="report-container">
        <div class="report-container__filter def-container">
          <div
            :class="
              titleType2 == -1
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check2(-1)"
          >
            全部（{{ this.totleMap2.qb }}）
          </div>
          <div
            :class="
              titleType2 == 0
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check2(0)"
          >
            国家级（{{ this.totleMap2.gj }}）
          </div>
          <div
            :class="
              titleType2 == 1
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check2(1)"
          >
            省级（{{ this.totleMap2.sj }}）
          </div>
          <div
            :class="
              titleType2 == 2
                ? 'report-container__filter__item is-active'
                : 'report-container__filter__item'
            "
            @click="check2(2)"
          >
            市级（{{ this.totleMap2.dsj }}）
          </div>
        </div>
      </div>
      <div class="def-container">
        <div class="box-card" v-for="(item, index) in policyData" :key="index">
          <el-row style="margin-bottom: 8px">
            <span style="color: #0069e8; font-size: 16px"
              >【{{ item.policyLevelName }}】</span
            >
            <span
              style="color: #333; font-weight: 700; font-size: 16px"
              @click="goDeclare(item)"
              >{{ item.policyName }}</span
            >
<!--            @click="tonewpage(item)"-->
            <!-- <span class="match" v-show="tsFlag == 'system'"
              >匹配度：{{ item.score }}%</span
            > -->
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">发文单位:</el-col>
            <el-col :span="20">{{ item.fbjg }}</el-col>
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">有效时间:</el-col>
            <el-col :span="20"
              >{{
                moment(item.startTime).format("YYYY-MM-DD")
              }}&nbsp;&nbsp;至&nbsp;&nbsp;{{ cpu_limitTime(item.endTime) }}
            </el-col>
          </el-row>
          <el-row class="box-line">
            <el-col :span="2" class="box-line-title">推送时间：</el-col>
            <el-col :span="20">{{ item.pushTime }}</el-col>
          </el-row>
          <div class="wssb">
            <el-button type="primary" @click="goDeclare(item)"
              >政策详情</el-button
            >
          </div>
        </div>
        <div class="qw-list-empty def-container" v-if="policyData.length == 0">
          <div class="qw-list-empty__inner">
            <div>
              <i class="el-icon-folder-delete"></i>
            </div>
            <div><span> 暂无数据 </span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="def-container">
      <el-pagination
        v-if="showPagination"
        class="content-pagination"
        style="margin-top: 20px"
        :total="pageInfo.total"
        :current-page.sync="pageInfo.num"
        background
        layout="total,prev,pager,next,jumper"
        @current-change="changePage"
      ></el-pagination>
    </div>
    <el-dialog
      title="请完善企业信息"
      :visible.sync="policyVisible"
      :modal-append-to-body="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="行业类别">
              <el-select
                v-model="form.sysCategory"
                multiple
                clearable
                collapse-tags
                placeholder="请选择行业类别"
                style="width: 100%"
                @change="selectChange($event, 'hylb')"
              >
                <el-option
                  v-for="dict in hyleList"
                  :key="dict.key"
                  :label="dict.label"
                  :value="dict.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产业类别">
              <el-select
                v-model="form.sysEnterTypeName"
                multiple
                clearable
                collapse-tags
                placeholder="请选择产业类别"
                style="width: 100%"
                @change="selectChange($event, 'cylb')"
              >
                <el-option
                  v-for="dict in cyleList"
                  :key="dict.key"
                  :label="dict.label"
                  :value="dict.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业资质">
              <el-select
                v-model="form.qyzz"
                multiple
                clearable
                collapse-tags
                placeholder="请选择企业资质"
                style="width: 100%"
                @change="selectChange($event, 'qyzz')"
              >
                <el-option
                  v-for="dict in qyzzList"
                  :key="dict.key"
                  :label="dict.label"
                  :value="dict.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业注册类型">
              <el-select
                v-model="form.qyzclx"
                multiple
                clearable
                collapse-tags
                placeholder="请选择注册类型"
                style="width: 100%"
                @change="selectChange($event, 'qyzclx')"
              >
                <el-option
                  v-for="dict in qyzclxList"
                  :key="dict.key"
                  :label="dict.label"
                  :value="dict.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册要求">
              <el-select
                v-model="form.zcyq"
                collapse-tags
                placeholder="请选择注册要求"
                style="width: 100%"
              >
                <el-option label="独立法人" value="0"></el-option>
                <el-option label="非独立法人" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纳税地">
              <el-select
                v-model="form.nsd"
                collapse-tags
                placeholder="请选择纳税地"
                style="width: 100%"
              >
                <el-option label="信阳市" value="0"></el-option>
                <el-option label="省内其他地市" value="1"></el-option>
                <el-option label="省外" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册地">
              <el-select
                v-model="form.zcd"
                collapse-tags
                placeholder="请选择纳税地"
                style="width: 100%"
              >
                <el-option label="信阳市" value="0"></el-option>
                <el-option label="省内其他地市" value="1"></el-option>
                <el-option label="省外" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统计关系所在地">
              <el-select
                v-model="form.tjgxszd"
                collapse-tags
                placeholder="请选择纳税地"
                style="width: 100%"
              >
                <el-option label="信阳市" value="0"></el-option>
                <el-option label="省内其他地市" value="1"></el-option>
                <el-option label="省外" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDiolog">取 消</el-button>
        <el-button type="primary" @click="submitFormNew()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tabActive: "policy",
      isFisrtQueryNum: true,
      isFisrtQueryNum2: true,
      showPagination: true,
      deptPolicyLevel: -1, //部门推荐的时候，政策级别
      deptPolicyLevel2: -1,
      tsFlag: "dept",
      titleType: -1,
      titleType2: -1,
      // 政策信息
      policyInfo: {
        data: [],
        deptData: [],
      },
      pageInfo: {
        total: 0,
        num: 1,
        size: 10,
      },
      total: "",
      data: {},
      json: {},
      form: {
        sysCategory: "",
        sysEnterTypeName: "",
        qyzz: "",
        qyzclx: "",
        zcyq: "",
        nsd: "",
        tjgxszd: "",
        zcd: "",
      },
      sysWebEnterpriseBaseinfo: {
        gwjjfl: "",
        zcyq: "",
        qynsd: "",
        cylx: "",
        enterprise_register_type: "",
        enterprise_qualification: "",
      },
      policyVisible: false,
      showFlag: true,
      totleMap: {},
      totleMap2: {},
      totleMapDept: {},
      // qyzclxList: [], //企业注册规模
      // hyleList: [], //行业类别
      // zcyqList: [], //注册要求
      // cyleList: [], //产业类别
      // nsdList: [], //纳税地
      // qysxList: [], //企业属性
      // qygmList: [], //企业规模
      // czzqList: [], //成长周期
      // qyflList: [], //企业分类
      hyleList: [], //行业类别
      cyleList: [], //产业类别
      qyzclxList: [], //企业注册类型
      qyzzList: [], //企业资质
      moment,
      loading: false,
      policyData: [], //政策推送
      policyData2:{     //  政策项目推送
        num: 0, //  推荐申报政策项目（符合申报条件）
        zj: 0,  //  预估可申报资金
      }
    };
  },
  components: {},
  created() {
    // this.getPolicyBySystem(1, 500);
    this.getPolicy();
    this.getQyInfo();
    // this.getPolicyBySystemNew();
    // this.getPolicyByDept();
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictLabel: "dictionary/getDictLabel",
    }),
    cpu_limitTime() {
      return function (endTime) {
        // if (endTime == undefined || endTime == "undefined") {
        //   return "";
        // } else if (endTime == "长期有效" || endTime.slice(0, 4) == "2099") {
        //   return "长期有效";
        // }
        // if(endTime){

        // }
        if (
          endTime == "Invalid date" ||
          endTime == undefined ||
          endTime == "undefined" ||
          endTime.slice(0, 4) == "2099"
        ) {
          return "长期有效";
        }
        return endTime ? endTime : "长期有效";
      };
    },
  },
  methods: {
    // 完善企业信息弹框的查询信息
    getQyInfo() {
      let url = "/dev-api/policy/evaluation/policySysMatchingQueryInfo";
      let param = {
        shxydm: this.userInfo.tyshxydm,
      };
      this.$httpApi
        .post(url, param)
        .then((res) => {
          let data = res.data;
          if (data.enterprise_qualification) {
            this.form.qyzz = data.enterprise_qualification.split(",");
          }
          if (data.enterprise_register_type) {
            this.form.qyzclx = data.enterprise_qualification.split(",");
          }
          if (data.cylx) {
            this.form.sysEnterTypeName = data.cylx.split(",");
          }
          if (data.gwjjfl) {
            this.form.sysCategory = data.gwjjfl.split(",");
          }
          this.form.nsd = data.qynsd;
          this.form.zcyq = data.zcyq;
          this.form.zcd = data.zcdz;
          this.form.tjgxszd = data.tjgxszd;
          let that = this;
          that.form;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    closeDiolog() {
      this.policyVisible = false;
      this.isFisrtQueryNum = true;
    },
    changeTab(param) {
      this.tabActive = param;
      if (param == "policy") {
        this.isFisrtQueryNum2 = true;
        this.getPolicy();
      } else {
        this.getPolicyByDept();
      }
    },
    radioChange(val) {
      // this.loading = true;
      // this.policyInfo.data = [];
      this.tsFlag = val;
      if (val == "dept") {
        // 调用部门推荐接口
        this.getPolicyByDept();
      } else {
        // this.getPolicyBySystem(1, 500);
        this.getPolicyBySystemNew();
      }
    },
    getPolicyByDept() {
      let that = this;
      that.showPagination = false;
      let url = "/dev-api/policyPush/policyPush/selectPushPolicys";
      let params = {
        pageNum: that.pageInfo.num,
        pageSize: that.pageInfo.size,
        shxydm: that.userInfo.tyshxydm,
      };
      if (that.deptPolicyLevel == -1) {
        delete params["policyLevel"];
      } else {
        params["policyLevel"] = that.deptPolicyLevel.toString();
      }
      that.$httpApi
        .post(url, params)
        .then((res) => {
          that.showPagination = true;
          switch (that.deptPolicyLevel) {
            case -1:
              that.pageInfo.total = res.data.allTotal;
              break;
            case 0:
              that.pageInfo.total = res.data.gjnum;
              break;
            case 1:
              that.pageInfo.total = res.data.sjnum;
              break;
            case 2:
              that.pageInfo.total = res.data.cjnum;
              break;
            default:
              break;
          }
          that.totleMapDept = {
            qb: res.data.allTotal,
            gj: res.data.gjnum,
            sj: res.data.sjnum,
            dsj: res.data.cjnum,
            zzxe: res.data.zzxe,
          };
          let temp = res.data.pageInfo.list;
          that.policyData2.num = 0;  //  置空
          that.policyData2.zj = 0;  //  置空
          that.policyInfo.deptData = (temp || []).map((cv) => {
            var aData = new Date();
            var year = aData.getFullYear(); //年
            var month = aData.getMonth(); //月
            if (month < 9) {
              month = "0" + (month + 1);
            }
            var day = aData.getDate(); //日
            let ndate = year + "-" + month + "-" + day;
            let startTime = cv.startTime.substr(0, 10);
            let endTime = cv.endTime ? cv.endTime.substr(0, 10) : ""; //年

            if (startTime < ndate && ndate < endTime) {
              cv["ksbflag"] = true; //  申报期
              if(cv.tkh){
                that.policyData2.zj += cv.tkh*1;
              }
              that.policyData2.num += 1;
            } else {
              cv["ksbflag"] = false;  //  非申报期
            }
            return {
              // xmId: cv.xmId,
              name: cv.itemName,
              deptname: cv.deptName,
              starttime: cv.startTime,
              endtime: cv.endTime,
              ksbflag: cv.ksbflag,
              policyName: cv.policyName,
              policyId: cv.policyId,
              sxid: cv.xmId,
              star: cv.star,
              areaid: cv.policyLevelName,
              zzxe: cv.tkh,
              pushTime: cv.pushTime,
            };
          });
          that.policyInfo.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    goDeclare(item) {
      if (this.tabActive == "policy") {
        let data = JSON.stringify(item);
        sessionStorage.setItem("policyDetailData", data);
        window.sessionStorage.setItem("flag", false);
        window.sessionStorage.setItem("status", false);
        let { href } = this.$router.resolve({
          name: "showPolicyDetail",
        });
        // window.open(href, "_blank");
        window.open(href, "_self");
      } else {
        this.$store.commit("updateCurrentGuideId", item.sxid);
        let { href } = this.$router.resolve({
          name: "guideSuqiu",
          query: {
            name: item.name,
            itemType: "2",
            isAdded: item.isAdded,
          },
        });
        window.open(href, "_blank");
      }
    },
    check(i) {
      this.titleType = i;
      this.deptPolicyLevel = i;
      if (this.tsFlag == "dept") {
        this.getPolicyByDept();
      } else {
        // this.getPolicyBySystem(1, 5);
        this.getPolicyBySystemNew();
      }
    },
    check2(i) {
      this.titleType2 = i;
      this.deptPolicyLevel2 = i;
      this.getPolicy();
    },
    tonewpage(item) {
      let data = JSON.stringify(item);
      let { href } = this.$router.resolve({
        name: "policyMatchDetails",
        query: {
          listData: data,
        },
      });
      window.open(href, "_blank");
    },
    changePage(page) {
      this.pageInfo.num = page;
      if (this.tsFlag == "dept") {
        this.getPolicyByDept();
      } else {
        // this.getPolicyBySystem(page, 5);
        this.getPolicyBySystemNew();
      }
    },
    getPolicyBySystemNew() {
      let that = this;
      let url = "/dev-api/policy/evaluation/policySysMatching";
      let params = {
        pageSize: that.pageInfo.size,
        pageNum: that.pageInfo.num,
        shxydm: that.userInfo.tyshxydm,
        sysWebEnterpriseBaseinfo: {},
      };
      if (this.policyVisible) {
        params.sysWebEnterpriseBaseinfo = this.sysWebEnterpriseBaseinfo;
        params.sysWebEnterpriseBaseinfo.zcyq = this.form.zcyq;
        params.sysWebEnterpriseBaseinfo.qynsd = this.form.nsd;
      }
      if (that.deptPolicyLevel == -1) {
        delete params["policyLevel"];
      } else {
        params["policyLevel"] = this.deptPolicyLevel.toString();
      }
      that.$httpApi
        .post(url, params)
        .then((res) => {
          that.showPagination = true;
          that.loading = false;
          if (res.code == 200) {
            that.pageInfo.total = res.data.allTotal;
            this.policyVisible = false;
            if (that.isFisrtQueryNum) {
              switch (that.deptPolicyLevel) {
                case -1:
                  that.pageInfo.total = res.data.allTotal;
                  break;
                case 0:
                  that.pageInfo.total = res.data.gjnum;
                  break;
                case 1:
                  that.pageInfo.total = res.data.sjnum;
                  break;
                case 2:
                  that.pageInfo.total = res.data.cjnum;
                  break;
                default:
                  break;
              }
              that.totleMap = {
                qb: res.data.allTotal,
                gj: res.data.gjnum,
                sj: res.data.sjnum,
                dsj: res.data.cjnum,
                zzxe: res.data.zzxe,
              };
            }
            this.isFisrtQueryNum = false;
            // if (that.titleType == "-1") {
            //   that.totleMap = res.data;
            // }
            // if (res.data.qyys) {
            //   that.form = res.data.qyys;
            //   if (!res.data.qyys.sysCategory) {
            //     res.data.qyys.sysCategory = [];
            //   }
            // }
            // if (!res.data.qyys) {
            //   that.policyVisible = true;
            //   that.showFlag = false;
            //   res.data.list = []; //如果企业信息没有完善 不显示数据
            // }
            let temp = res.data.passList;
            that.policyInfo.data = (temp || []).map((cv) => {
              var aData = new Date();
              var year = aData.getFullYear(); //年
              var month = aData.getMonth(); //月
              if (month < 9) {
                month = "0" + (month + 1);
              }
              var day = aData.getDate(); //日
              let ndate = year + "-" + month + "-" + day;
              let startTime = cv.startTime ? cv.startTime.substr(0, 10) : "";
              let endTime = cv.endTime ? cv.endTime.substr(0, 10) : "长期有效"; //年
              if (startTime < ndate && ndate < endTime) {
                cv.ksbflag = true;
              } else {
                cv.ksbflag = false;
              }
              return {
                // xmId: cv.xmId,
                name: cv.NAME,
                deptname: cv.fbjg,
                starttime: cv.startTime,
                endtime: cv.endTime,
                ksbflag: cv.ksbflag,
                policyName: cv.policyName,
                policyId: cv.policyId,
                sxid: cv.id,
                areaid: cv.policyLevelName,
                ppd: cv.score,
                zzxe: cv.tkh,
              };
            });
            that.policyInfo.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // getPolicyBySystem(pageNum, pageSize) {
    //   let that = this;
    //   that.showPagination = false;
    //   pageNum && (this.pageInfo.num = pageNum);
    //   pageSize && (this.pageInfo.size = pageSize);
    //   let url = "/dev-api/policy/evaluation/recommend";
    //   let params = {};
    //   if (this.titleType != -1) {
    //     params = {
    //       shxydm: this.userInfo.tyshxydm,
    //       pageNum: this.pageInfo.num,
    //       pageSize: this.pageInfo.size,
    //       areaid: this.titleType,
    //     };
    //   } else {
    //     params = {
    //       shxydm: this.userInfo.tyshxydm,
    //       pageNum: this.pageInfo.num,
    //       pageSize: this.pageInfo.size,
    //     };
    //   }
    //   this.$httpApi
    //     .get(url, params)
    //     .then((res) => {
    //       that.showPagination = true;
    //       if (res.code == 200) {
    //         that.pageInfo.total = res.data.qb;
    //         if (that.titleType == "-1") {
    //           that.totleMap = res.data;
    //         }
    //         if (res.data.qyys) {
    //           that.form = res.data.qyys;
    //           if (!res.data.qyys.sysCategory) {
    //             res.data.qyys.sysCategory = [];
    //           }
    //         }
    //         if (!res.data.qyys) {
    //           this.policyVisible = true;
    //           this.showFlag = false;
    //           res.data.list = []; //如果企业信息没有完善 不显示数据
    //         }
    //         /**
    //          * 20210628
    //          * 2个人写了2个接口，返回的数据格式不一样
    //          * 用map同步一下
    //          */
    //         that.policyInfo.data = (res.data.list || []).map((cv) => {
    //           var aData = new Date();
    //           var year = aData.getFullYear(); //年
    //           var month = aData.getMonth(); //月
    //           if (month < 9) {
    //             month = "0" + (month + 1);
    //           }
    //           var day = aData.getDate(); //日
    //           let ndate = year + "-" + month + "-" + day;
    //           let startTime = cv.startTime.substr(0, 10);
    //           let endTime = cv.endTime.substr(0, 10); //年
    //           if (startTime < ndate && ndate < endTime) {
    //             cv.ksbflag = true;
    //           } else {
    //             cv.ksbflag = false;
    //           }
    //           return {
    //             xmId: cv.xmId,
    //             name: cv.xmName,
    //             deptname: cv.deptName,
    //             starttime: cv.startTime,
    //             endtime: cv.endTime,
    //             ksbflag: cv.ksbflag,
    //             policyName: cv.policyName,
    //             policyId: cv.policyId,
    //             sxid: cv.xmId,
    //             // star: cv.star,
    //             areaid: cv.areaid,
    //             zzxe: cv.zzxe,
    //             ppd: cv.ppd,
    //             sysCategoryName: cv.sysCategoryName,
    //             enterpriseSizeName: cv.enterpriseSizeName,
    //             enterpriseAttributesName: cv.enterpriseAttributesName,
    //             growthCycleName: cv.growthCycleName,
    //             sysEnterTypeName: cv.sysEnterTypeName,
    //             enterpriseTypeName: cv.enterpriseTypeName,
    //             sysEnterpriseRegistertypeName: cv.sysEnterpriseRegistertypeName,
    //             requireRegist: cv.requireRegist,
    //             paymentPlace: cv.paymentPlace,
    //             mainbusinessIncome: cv.mainbusinessIncome,
    //             lastIncomeTax: cv.lastIncomeTax,
    //             json: cv.json,
    //             sysCategoryPp: cv.sysCategoryPp,
    //             enterpriseSizePp: cv.enterpriseSizePp,
    //             enterpriseAttributesPp: cv.enterpriseAttributesPp,
    //             growthCyclePp: cv.growthCyclePp,
    //             sysEnterTypePp: cv.sysEnterTypePp,
    //             enterpriseTypePp: cv.enterpriseTypePp,
    //             requireRegistPp: cv.requireRegistPp,
    //             paymentPlacePp: cv.paymentPlacePp,
    //             sysEnterpriseRegistertypePp: cv.sysEnterpriseRegistertypePp,
    //             mainbusinessIncomePp: cv.mainbusinessIncomePp,
    //             lastIncomeTaxPp: cv.lastIncomeTaxPp,
    //             ppTotle: cv.ppTotle,
    //             ppNum: cv.ppNum,
    //             shxydm: cv.shxydm,
    //             zzbzData: [{ zzqx: cv.supportStandard }],
    //           };
    //         });
    //         console.log("data------", that.policyInfo.data);
    //         for (let i = 0; i < that.policyInfo.data.length; i++) {
    //           that.runPolicyStarCalculate(that.policyInfo.data[i]);
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       console.log("getPolicyBySystem error:", err);
    //     });
    // },
    areaTotle() {
      let url = "/dev-api/policy/evaluation/areaTotle";
      let params = {
        shxydm: this.userInfo.tyshxydm,
      };
      this.$httpApi
        .get(url, params)
        .then((res) => {
          if (res.code == 200) {
            this.totleMap = res.data;
          } else {
            console.log("runPolicyStarCalculate error:", err);
          }
          // console.log('runPolicyStarCalculate:', res)
        })
        .catch((err) => {
          console.log("runPolicyStarCalculate error:", err);
        });
    },
    openPolicy() {
      this.policyVisible = true;
    },
    selectChange(e, param) {
      switch (param) {
        // 企业资质
        case "qyzz":
          this.sysWebEnterpriseBaseinfo.enterprise_qualification = e.join(",");
          break;
        // 行业类别
        case "hylb":
          this.sysWebEnterpriseBaseinfo.gwjjfl = e.join(",");
          break;
        // 产业类别
        case "cylb":
          this.sysWebEnterpriseBaseinfo.cylx = e.join(",");
          break;
        // 企业注册类型
        case "qyzclx":
          this.sysWebEnterpriseBaseinfo.enterprise_register_type = e.join(",");
          break;
        default:
          break;
      }
    },
    submitForm() {
      this.loading = true;
      let self = this;
      let params = {
        shxydm: self.userInfo.tyshxydm,
        form: JSON.stringify(self.form),
      };
      this.$httpApi
        .post("/dev-api/biq/updateSyswebE", params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("保存成功！");
            JSON.stringify(self.form);
            this.policyVisible = false;
          } else {
            this.$message.error("保存失败！");
          }
        })
        .catch((err) => {
          this.$message.error("保存失败！");
          this.loading = false;
        });
      setTimeout(() => {
        // this.getPolicyBySystem(1, 500);
        this.getPolicyBySystemNew();
        this.loading = false;
      }, 1000);
    },
    submitFormNew() {
      // this.isFisrtQueryNum = true;
      // this.getPolicyBySystemNew();
      let url = "/dev-api/policy/evaluation/policySysMatchingUpdateInfo";
      let param = this.sysWebEnterpriseBaseinfo;
      param["shxydm"] = this.userInfo.tyshxydm;
      param.zcyq = this.form.zcyq;
      param.qynsd = this.form.nsd;
      param.zcdz = this.form.zcd;
      param.tjgxszd = this.form.tjgxszd;
      param.gwjjfl = this.form.sysCategory.join(",");
      param.cylx = this.form.sysEnterTypeName.join(",");
      param.enterprise_register_type = this.form.qyzclx.join(",");
      param.enterprise_qualification = this.form.qyzz.join(",");
      this.$httpApi
        .post(url, param)
        .then((res) => {
          this.isFisrtQueryNum = true;
          if (res.code == 200) {
            this.$message.success("保存成功！");
            this.policyVisible = false;
            this.getPolicyBySystemNew();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    init() {
      this.gethyleList(); //行业类别
      this.getcyleList(); //产业类别
      this.getqyzclxList(); //企业注册类型
      this.getQyzzList(); //企业资质
    },
    getlist(urlid) {
      let that = this;
      if (urlid) {
        that.$httpApi
          .get(`/dev-api/system/dict/getDictListByType?dictType=${urlid}`, {})
          .then((res) => {
            if (res.code == 200) {
              switch (urlid) {
                // 行业类别
                case "sys_category":
                  that.hyleList = res.data;
                  break;
                // 产业类别
                case "sys_enter_type":
                  that.cyleList = res.data;
                  break;
                // 企业注册类型
                case "enterprise_register_type":
                  that.qyzclxList = res.data;
                  break;
                // 企业资质
                case "enterprise_qualification":
                  that.qyzzList = res.data;
                  break;
                // case "enterprise_attributes":
                //   that.qysxList = res.data;
                //   break;
                // case "enterprise_size":
                //   that.qygmList = res.data;
                //   break;
                // case "growth_cycle":
                //   that.czzqList = res.data;
                //   break;
                // case "qy_type":
                //   that.qyflList = res.data;
                //   break;
                default:
                  break;
              }
            } else {
              return [];
            }
          })
          .catch((err) => {});
      }
    },
    // 获取行业类别
    gethyleList() {
      let urlid = "sys_category";
      this.getlist(urlid);
    },
    // 获取产业类别
    getcyleList() {
      let urlid = "sys_enter_type";
      this.getlist(urlid);
    },
    // 获取企业资质
    getQyzzList() {
      let urlid = "enterprise_qualification";
      this.getlist(urlid);
    },
    // 获取企业注册类型
    getqyzclxList() {
      let urlid = "enterprise_register_type";
      this.getlist(urlid);
    },
    // // 获取企业属性
    // getqysxList() {
    //   let urlid = "enterprise_attributes";
    //   this.getlist(urlid);
    // },
    // // 获取企业规模
    // getqygmList() {
    //   let urlid = "enterprise_size";
    //   this.getlist(urlid);
    // },
    // // 获取成长周期
    // getczzqList() {
    //   let urlid = "growth_cycle";
    //   this.getlist(urlid);
    // },
    // getqyflList() {
    //   let urlid = "qy_type";
    //   this.getlist(urlid);
    // },
    getPolicy() {
      let that = this;
      that.showPagination = false;
      // let url = "/dev-api/policy/evaluation/policyPushMatching";
      let url = "/dev-api/sqPolicyPush/push/selectSqPushPolicys";
      let params = {
        pageNum: that.pageInfo.num,
        pageSize: that.pageInfo.size,
        shxydm: that.userInfo.tyshxydm,
      };
      if (that.deptPolicyLevel2 == -1) {
        params["policyLevel"] = "";
      } else {
        params["policyLevel"] = that.deptPolicyLevel2.toString();
      }
      that.$httpApi
        .post(url, params)
        .then((res) => {
          that.showPagination = true;
          switch (that.deptPolicyLevel2) {
            case -1:
              that.pageInfo.total = res.data.allTotal;
              break;
            case 0:
              that.pageInfo.total = res.data.gjnum;
              break;
            case 1:
              that.pageInfo.total = res.data.sjnum;
              break;
            case 2:
              that.pageInfo.total = res.data.cjnum;
              break;
            default:
              break;
          }
          if (that.isFisrtQueryNum2) {
            that.totleMap2 = {
              qb: res.data.allTotal,
              gj: res.data.gjnum,
              sj: res.data.sjnum,
              dsj: res.data.cjnum,
              zzxe: res.data.zzxe,
            };
          }
          this.isFisrtQueryNum2 = false;
          this.policyData = res.data.pageInfo.list;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style lang='scss' scoped>
::v-deep .el-pagination {
  padding: 20px 5px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #e6503b;
}
.wssb {
  width: 117px;
  height: 34px;
  position: absolute;
  top: 100px;
  right: 119px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  z-index: 2;
}
.mainCont {
  width: 100%;
  height: 200px;
  background: url("~@/assets/images/sub_banner.png") no-repeat 100% /
    cover;
  display: flex;
  align-items: center;
  .def-container {
    .main_title {
      font-size: 28px;
      color: #fff;
      font-weight: 700;
      margin-bottom: 15px;
    }
    .desc {
      margin-bottom: 15px;
      color: #fff;
      letter-spacing: 2px;
    }
    .line {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .line_label {
        font-size: 16px;
        color: #fff;
        font-weight: 600;
      }
      .line_value {
        font-size: 16px;
        font-weight: 600;
        color: #fff;
      }
    }
    .line_link {
      font-size: 16px;
      color: #3c67a8;
      text-decoration: underline;
    }
  }
}
.tabCon {
  width: 100%;
  height: 60px;
  padding: 20px 10px;
  cursor: pointer;
  .tabItem {
    width: 160px;
    height: 45px;
    font-size: 18px;
    background: #fff;
    line-height: 45px;
    text-align: center;
    border-radius: 3px;
    color: #000;
    font-weight: 600;
    margin-right: 20px;
    &:hover {
      // border-bottom: 3px solid #e0240a;
      // color: #e0240a;
      background: #e0240a;
      color: #fff;
    }
  }
  .clicked {
    background: #e0240a;
    color: #fff;
  }
}
.navRadio {
  width: 100%;
  height: 60px;
  padding-top: 5px;
  // background: #f0f2f5;
  position: absolute;
  top: 28.75rem;
  left: 0;
  // ::v-deep .el-radio-button__inner {
  //   padding: 16px 50px;
  //   border: 4px !important;
  //   margin-right: 20px;
  //   box-shadow: none;
  // }
  // ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  //   background-color: #e0240a !important;
  // }
  .radioItem {
    cursor: pointer;
    font-size: 20px;
    text-align: center;
    color: #000;
    font-weight: 600;
    margin-right: 20px;
    &:hover {
      border-bottom: 3px solid #e0240a;
      color: #e0240a;
    }
  }
  .clicked {
    border-bottom: 3px solid #e0240a;
    color: #e0240a;
  }
}
.home-title {
  height: 50px;
  line-height: 2.5;
  width: 100%;
  background-color: #d4dff2;
  .home-title_1 {
    height: 100%;
    width: 60%;
    margin-left: 15%;
    .home-title_2 {
      height: 100%;
      width: 221px;
      float: left;
      text-align: center;
      font-size: 17px;
      padding: 8px;
      cursor: pointer;
    }
    // .home-title_2:hover {
    //   height: 100%;
    //   width: 221px;
    //   float: left;
    //   text-align: center;
    //   font-size: 17px;
    //   padding: 8px;
    //   cursor: pointer;
    //   color: #ffffff;
    //   background-color: #0069e8;
    // }
    .home-title_2s {
      height: 100%;
      width: 221px;
      float: left;
      text-align: center;
      font-size: 17px;
      padding: 8px;
      cursor: pointer;
      color: #ffffff;
      background-color: #0069e8;
    }
    .home-title_3 {
      color: #000000;
    }
    .home-title_3:hover {
      color: #ffffff;
    }
  }
}
.report-container {
  background-color: #f0f2f5;
  // margin-bottom: 80px;
  .report-container__filter {
    @media screen and (min-width: 1366px) {
      max-width: 1182px;
    }
    @media screen and (min-width: 1600px) {
      max-width: 1340px;
    }
    @media screen and (min-width: 1920px) {
      max-width: 1470px;
    }
    margin: 0 auto;
    display: flex;
    align-items: center;
    .report-container__filter__item {
      width: 126px;
      height: 53px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #333;
      cursor: pointer;
      text-align: center;
    }
    .report-container__filter__item.is-active {
      font-size: 18px;
      color: #0069e8;
    }
  }
}
.qw-list-empty {
  width: 100%;
  min-height: 200px;
  height: 20vh;
  position: relative;
  background: #fff;
  .qw-list-empty__inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #989899;
    span {
      font-size: 18px;
      line-height: 24px;
    }
    i {
      font-size: 36px;
      line-height: 80px;
    }
  }
}
.box-card {
  max-width: 1260px;
  margin: 20px auto;
  min-height: 158px;
  position: relative;
  background: #fff;
  cursor: pointer;
  // box-shadow: 1px 1px 1px 1px #ccc;
  border: 1px solid #fff;
  border-radius: 10px;
  padding: 10px 8px;
  .box-line {
    margin-bottom: 6px;
    display: flex;
    font-size: 18px;
    color: #666;
    line-height: 20px;
    .box-line-title {
      font-weight: 600;
    }
  }
}
.match {
  cursor: pointer;
  display: block;
  font-size: 12px;
  border: 1px solid #cce1fa;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
  float: right;
  margin-right: 10%;
}
.zct-policy-item-comp__rect:before {
  content: "";
  width: 0;
  height: 0;
  border-bottom: 34px solid #fff;
  border-right: 14px solid transparent;
  position: absolute;
  bottom: 0;
  left: 0;
}
.zct-policy-item-comp__rect.is-grey {
  background-color: #9b9b9b;
}
.zct-policy-item-comp__rect.is-blue {
  background-color: #89dc4a;
}
.zct-policy-item-comp__rect {
  width: 117px;
  height: 34px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #a71d1d;
  font-size: 18px;
  color: #fff;
  z-index: 2;
}
</style>
